import React, { useState, useEffect } from 'react'
import {
    CButton, CCard, CBadge,
    CButtonGroup,
    CCardBody,
    CCardFooter,
    CCardHeader,
    CCol,
    CProgress,
    CRow,
    CImg,
    CCallout
} from 'compat/coreui';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { useSelector, connect, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { postData, getData } from '../../../helpers/api';

export default function Gallary(props) {
    const [profileImg, setProfileImage] = useState("");
    const [coverImg, setCoverImage] = useState("");
    const [promoImg, setPromoImage] = useState([]);
    const [selectedFile, setSelectedFile] = useState("");
    const [promoImages, setPromoImages] = useState([]);
    const dispatch = useDispatch()
    const history = useNavigate()
    const { handleSubmit, reset } = props;
    const blobToFile = (theBlob, fileName) => {
        //A Blob() is almost a File() - it's just missing the two properties below which we will add
        // theBlob.lastModifiedDate = new Date().toDateString();
        // theBlob.name = fileName;
        return new File([theBlob], fileName);;
    }
    const setProfilePic = (selectedImg) => {
        console.log("profile image =>>>");
        const selectedFile = selectedImg.files[0];
        setProfileImage(URL.createObjectURL(selectedFile))
        setSelectedFile(selectedFile)
    }
    const setCoverPic = (coverImg) => {
        const selectedFile = coverImg.files[0];
        setPromoImage(URL.createObjectURL(coverImg.files[0]))
        setSelectedFile(selectedFile)
    }
    const setPromoPic = (coverImg) => {
        const selectedFile = coverImg.files[0];
        promoImages.push(URL.createObjectURL(coverImg.files[0]))
        setSelectedFile(selectedFile)
    }
    const submitProfileImg = (e) => {
        e.preventDefault();
        let url = `${process.env.REACT_APP_APP_API_URL}/api/profilepic`
        let formData = new FormData();
        formData.append("photos", selectedFile);
        const config = {
            headers: {
                'content-type': 'multipart/form-data',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        }
        return axios.post(url, formData, config).then(response => {
            if (response.status === 200) {
                toast.success("Image uploaded Successful!");
                dispatch(reset('sellerForm'));
                history('/profile')
            }
        }).catch(e => {
            if (e && e.response && e.response.data.message) {
                toast.error(e.response.data.message);
            }
        })
    }
    const submitCoverImg = (e) => {
        e.preventDefault();
        let url = `${process.env.REACT_APP_APP_API_URL}/api/coverimg`
        let formData = new FormData();
        formData.append("photos", selectedFile);
        const config = {
            headers: {
                'content-type': 'multipart/form-data',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        }
        return axios.post(url, formData, config).then(response => {
            if (response.status === 200) {
                toast.success("Image uploaded Successful!");
                dispatch(reset('sellerForm'));
                history('/profile')
            }
        }).catch(e => {
            if (e && e.response && e.response.data.message) {
                toast.error(e.response.data.message);
            }
        })
    }
    const submitPromoImg = (e) => {
        e.preventDefault();
        let url = `${process.env.REACT_APP_APP_API_URL}/api/promopics`
        let formData = new FormData();
        formData.append("photos", selectedFile);
        const config = {
            headers: {
                'content-type': 'multipart/form-data',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        }
        return axios.post(url, formData, config).then(response => {
            if (response.status === 200) {
                toast.success("Image uploaded Successful!");
                dispatch(reset('sellerForm'));
                history('/dashboard/gallery')
            }
        }).catch(e => {
            if (e && e.response && e.response.data.message) {
                toast.error(e.response.data.message);
            }
        })
    }
    useEffect(async () => {
        getUser()
        // setPromoImages(["s", "ss", "sss"])
    }, [])
    const getUser = () => {
        getData(`${process.env.REACT_APP_APP_API_URL}/api/user`).then(res => {
            if (res.data.status) {
                setProfileImage("https://pub-94bb2fa9f3f74a4d814557af59abaf7f.r2.dev/seller/" + res.data.user.image)
                setCoverImage("https://pub-94bb2fa9f3f74a4d814557af59abaf7f.r2.dev/seller/" + res.data.user.coverImage)
                setPromoImages(res.data.user.promoImage.map((i) => "https://pub-94bb2fa9f3f74a4d814557af59abaf7f.r2.dev/seller/" + i))
            }
        }).catch(console.log)
    };
    return (
        <React.Fragment>
            <CCard className="business-dashboard">
                <ul className="c_8 timeline">
                    <li id="new_post">
                        <div className="review-headding">
                            <h2>Profile Photo</h2>
                            <div className="textarea_wrap">
                                <form method="post" action="?action=new_post" id="new_post_form" encType="multipart/form-data" className="fu_form">
                                    <CCol>
                                        <div>
                                            <div className="fu_wrap single" id="post_file">
                                                <p><span className="required">Note:</span> Click and drag photos to reorder your gallery. Your first photo is your profile photo</p>
                                                <div className="fileUpload btn btn-primary">
                                                    <span>Add a Photo</span>
                                                    <input type="file" className="upload" name="photos" onChange={(e) => setProfilePic(e.target)} />
                                                </div>
                                            </div>
                                            <img style={{ maxWidth: "60%", maxHeight: "200px" }} id="target" src={profileImg} />
                                        </div>
                                    </CCol>
                                    <CButton color="success" size="lg" className="m-3" onClick={(e) => submitProfileImg(e)}>Save</CButton>
                                </form>
                            </div>
                        </div>
                    </li>
                </ul>
            </CCard>
            <CCard className="business-dashboard">
                <ul className="c_8 timeline">
                    <li id="new_post">
                        <div className="review-headding">
                            <h2>Cover Photo</h2>
                            <div className="textarea_wrap">
                                <form method="post" action="?action=new_post" id="new_post_form" encType="multipart/form-data" className="fu_form">
                                    <div>
                                        <div className="fu_wrap single" id="post_file">
                                            <p><span className="required">Note:</span> Click and drag photos to reorder your gallery. Your first photo is your profile photo</p>
                                            <div className="fileUpload btn btn-primary">
                                                <span>Add a Photo</span>
                                                <input type="file" className="upload" onChange={(e) => setCoverPic(e.target)} />
                                            </div>
                                        </div>
                                        <img style={{ maxWidth: "60%", maxHeight: "200px" }} id="cover" name="photos" src={coverImg} />
                                    </div>
                                    <CButton color="success" size="lg" className="m-3" onClick={(e) => submitCoverImg(e)}>Save</CButton>
                                </form>
                            </div>
                        </div>
                    </li>
                </ul>
            </CCard>
            <CCard className="business-dashboard">
                <ul className="c_8 timeline">
                    <li id="new_post">
                        <div className="review-headding">
                            <h2>Promo Photos</h2>
                            <div className="textarea_wrap">
                                <form method="post" action="?action=new_post" id="new_post_form" encType="multipart/form-data" className="fu_form">
                                    <div>
                                        <div className="fu_wrap single" id="post_file">
                                            <p><span className="required">Note:</span> Click and drag photos to reorder your gallery. Your first photo is your profile photo</p>
                                            <div className="fileUpload btn btn-primary">
                                                <span>Add a Photo</span>
                                                <input type="file" className="upload" onChange={(e) => setPromoPic(e.target)} />
                                            </div>
                                        </div>
                                        <CRow>
                                            {promoImages.map((item, index) => {
                                                return (<CCol sm="3" className="m-auto" key={index}>
                                                    <div style={{ marginBottom: "5%" }}>
                                                        <CImg style={{ maxWidth: "100%" }} src={item} />
                                                    </div>
                                                </CCol>)
                                            })}
                                        </CRow>
                                        {/* <img style={{ maxWidth: "60%", maxHeight: "200px" }} id="target" src={profileImg} /> */}
                                    </div>
                                    <CButton color="success" size="lg" className="m-3" onClick={(e) => submitPromoImg(e)}>Save</CButton>
                                </form>
                            </div>
                        </div>
                    </li>
                </ul>
            </CCard>
        </React.Fragment>
    )
}